import {PANEL_TYPES} from "./constants";
import {checkElementOrAncestorHasClass} from '../atBrowserUtils'
import UserNameFormat from '../util/UserNameFormat'

/**
 * Sets property to event. Uses when needs to prevent element hiding.
 * @param e Event.
 * @param elementType Unique type of element that is needed to prevent from hiding.
 */
export function setEventPreventHiding(e, elementType) {
    e.originalEvent[getPropertyName(elementType)] = true
}

export function shouldEventPreventHiding(e, elementType) {
    return (e.originalEvent && e.originalEvent[getPropertyName(elementType)]) || checkElementOrAncestorHasClass(e.target, 'preventPanelsHiding')
}

function getPropertyName(elementType) {
    return '_at_' + elementType + '_preventHiding'
}

export function setEventPreventHidingEditUserSlidingPanel(e) {
    setEventPreventHiding(e, PANEL_TYPES.EDIT_USER)
}

export function shouldEventPreventHidingEditUserSlidingPanel(e) {
    return shouldEventPreventHiding(e, PANEL_TYPES.EDIT_USER)
}

export function setEventPreventHidingEditProjectSlidingPanel(e) {
    setEventPreventHiding(e, PANEL_TYPES.EDIT_PROJECT)
}

export function shouldEventPreventHidingEditProjectSlidingPanel(e) {
    return shouldEventPreventHiding(e, PANEL_TYPES.EDIT_PROJECT)
}

export function setEventPreventHidingEditCustomerSlidingPanel(e) {
    setEventPreventHiding(e, PANEL_TYPES.EDIT_CUSTOMER)
}

export function shouldEventPreventHidingEditCustomerSlidingPanel(e) {
    return shouldEventPreventHiding(e, PANEL_TYPES.EDIT_CUSTOMER)
}

export function setEventPreventHidingEditTaskSlidingPanel(e) {
    setEventPreventHiding(e, PANEL_TYPES.EDIT_TASK)
}

export function shouldEventPreventHidingEditTaskSlidingPanel(e) {
    return shouldEventPreventHiding(e, PANEL_TYPES.EDIT_TASK)
}

export function setEventPreventHidingCreateTaskSlidingPanel(e) {
    setEventPreventHiding(e, PANEL_TYPES.CREATE_TASK)
}

export function setEventPreventHidingWorkAssignmentSlidingPanel(e) {
    setEventPreventHiding(e, PANEL_TYPES.WORK_ASSIGNMENTS_PANEL)
}

export function shouldEventPreventHidingWorkAssignmentSlidingPanel(e) {
    return shouldEventPreventHiding(e, PANEL_TYPES.WORK_ASSIGNMENTS_PANEL)
}

export function setEventPreventHidingTeamAssignmentSlidingPanel(e) {
    setEventPreventHiding(e, PANEL_TYPES.TEAM_ASSIGNMENT)
}

export function shouldEventPreventHidingTeamAssignmentSlidingPanel(e) {
    return shouldEventPreventHiding(e, PANEL_TYPES.TEAM_ASSIGNMENT)
}

export function setEventPreventHidingWorkAssignmentsEditorSlidingPanel(e) {
    setEventPreventHiding(e, PANEL_TYPES.WORK_ASSIGNMENTS_EDITOR)
}

export function setEventPreventHidingManagementAssignmentsEditorSlidingPanel(e) {
    setEventPreventHiding(e, PANEL_TYPES.MANAGEMENT_ASSIGNMENTS_EDITOR)
}

export function setEventPreventHidingManagementAssignmentsSlidingPanel(e) {
    setEventPreventHiding(e, PANEL_TYPES.MANAGEMENT_ASSIGNMENTS_PANEL)
}

export const resolveAuditActions = (auditActions, dependencies, auditType) => {
    for (let auditAction of auditActions) {
        if (auditAction['data'])
            auditAction['data'] = JSON.parse(auditAction['data']);
        auditAction['subject']['data'] = JSON.parse(auditAction['subject']['data']);
        auditAction['dependencies'] = auditAction['dependencies']
            .list
            .map(key => {
                const found = dependencies.find(dependency => dependency['type'] === key['type'] && dependency['id'] === key['id']);
                if (_.isString(found['data'])) {
                    found['data'] = JSON.parse(found['data']);
                }
                return found;
            });
        auditAction.object = {type: auditType};
    }
    return auditActions;
}

export const getFakeUpdateAuditAction = (loggedInUser) => {
    const updateAction = {
        timestamp: currentUserTime().format(Date.JSON_TIME_FORMAT),
        subject: {
            data: JSON.stringify({name: UserNameFormat.formatLFM(loggedInUser.firstName, loggedInUser.lastName, loggedInUser.middleName)})
        },
        type: null, //we don't need to specify type, because we don't know what event happened
    }
    return updateAction
}



// WEBPACK FOOTER //
// ./web/js/panels/utils.js